import { AppRouter } from "./routes/AppRouter"
import { createGlobalStyle } from 'styled-components';


const GlobalStyles = createGlobalStyle`

body {
  color: #221c35;
  font-family: 'Avant Garde','Helvetica Neue',Helvetica,Arial,sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.42857143;
  font-size: 1.03rem;
  padding: 0;
  margin: 0;
}

a {
  text-decoration: none;
}
p{
  margin: 0;
}
strong {
  font-weight: bolder;
}

button {
  font-family: 'Avant Garde','Helvetica Neue',Helvetica,Arial,sans-serif;
}
`;


export const TrackingApp = () => {
  return (
    <>
      <GlobalStyles />
      <AppRouter />
    </>
    
  )
}
